import React, { useEffect, useState } from 'react';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(!entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  const scrollToBuy = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className={`fixed bottom-0 left-0 right-0 bg-[rgba(13,10,14,0.95)] backdrop-blur-[10px] border-t border-pink p-[12px_20px] flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4 z-[100] transition-transform duration-300 ease-in-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-131">
      <div className="flex flex-col text-center sm:text-left" data-id="element-132">
        <span className="text-[13px] text-muted" data-id="element-133">
          Método Completo + 8 Bonos
        </span>
        <span className="font-bebas text-[24px] text-gold leading-none" data-id="element-134">
          $14.999 ARS — Pago único
        </span>
      </div>
      <button onClick={scrollToBuy} className="bg-pink text-white font-bebas text-[16px] tracking-[2px] py-3 px-7 rounded border-none cursor-pointer whitespace-nowrap hover:bg-pink-light transition-colors w-full sm:w-auto" data-id="element-135">
        COMPRAR AHORA →
      </button>
    </div>;
}